import { Link } from "./LinkF"

export const PtLink = (props) => {
  return <Link {...{cursor: 'pointer', ...props}} />
}

export const PtBluLink = (props) => {
  return <PtLink {...{color: 'blue.500', ...props}} />
}

export const PtUndLink = (props) => {
  return <PtBluLink {...{_hover: {textDecor: 'underline'}, ...props}} />
}
